import React from 'react';
import { connect } from 'react-redux';
import { setDocumentPayed } from '../../redux/actions/rootAction';
import { payedValue } from '../helpers/utils';
import withDocumentCommon from '../helpers/withDocumentCommon';

export default function withPayment(WrappedComponent) {
  // noinspection JSPotentiallyInvalidUsageOfThis
  class withPaymentWrapper extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  const mapStateToProps = (state, ownProps) => {
    const document = ownProps.document;
    return {
      document: document,
      payed: payedValue(document, state.documentsStatus),
      companyName: state.companyName,
      recipientRequestId: state.recipientRequestId
    };
  };

  const mapDispatchToProps = dispatch => ({
    setDocumentPayed: (documentId, method) =>
      dispatch(setDocumentPayed(documentId, method))
  });

  return withDocumentCommon(
    connect(mapStateToProps, mapDispatchToProps)(withPaymentWrapper)
  );
}
